{
	"title": "Verfügbare Materialien",
	"showAllTitle": "Alle Materialien anzeigen",
	"table": {
		"material": "Material",
		"invoicedQuantity": "In Rechnung gestellte Menge",
		"remainingForTransfer": "Verbleibend für die Erstellung der Erklärung",
		"fetchError": "Materialien konnten nicht abgerufen werden",
		"noMaterials": {
			"title": "Keine Materialien verfügbar",
			"description": "Sie haben derzeit keine Materialien auf dem {{productName}} verfügbar. Bitte wenden Sie sich an Ihren Vertriebsmitarbeiter, um Ihre Verträge zu Ihrem Konto hinzuzufügen."
		}
	}
}
